import React, { useLayoutEffect, useState } from "react";
import { Alert, Card, CardBody, CardText, CardTitle, Col, Row } from "reactstrap";
import styles from "./style.module.scss";
import cx from "classnames";
import LoadingPlaceholder from "components/LoadingPlaceholder";
import { getPoBox } from "api/POBoxApi";
import { errorHandler } from "utils/Api";
import { poBoxLabelGenerator } from "utils/Form";

const POBoxDetails = (props) => {
  const { className, poBoxId } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [isPoBoxError, setIsPoBoxError] = useState(false);
  const [poBox, setPoBox] = useState({});
  const poBoxLabel = poBoxLabelGenerator(poBox);

  useLayoutEffect(() => {
    setIsLoading(true);
    fetchPOBox();
  }, []);

  const fetchPOBox = async () => {
    getPoBox(poBoxId).then((r) => {
      setPoBox(r);
    }).catch((e) => {
      setIsPoBoxError(true);
      errorHandler(e)
    }).finally((e) => setIsLoading(false));
  }

  return (
    <div className={className}>
      <Card className={cx(["h-100", className])}>
        < CardBody className={styles.cardBody} >
          <CardTitle tag="h5" className={styles.cardTitle} >
            <LoadingPlaceholder isLoading={isLoading}>
              Informacion de Casillero
            </LoadingPlaceholder>
          </CardTitle>
          <CardText className={styles.cardText} >
            {isPoBoxError && (
              <Alert
                color="danger"
              >
                No ha sido posible encontrar la informacion del casillero
              </Alert>
            )}
            {!isPoBoxError && (
              <LoadingPlaceholder className={styles.po_address} isLoading={isLoading}>
                {!isPoBoxError && (
                  <>
                    <Row>
                      <Col className="text-end" xs="6">
                        <b>Numero Casillero: </b>
                      </Col>
                      <Col xs="6">
                        {poBoxLabel}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-end" xs="6">
                        <b>Nombre: </b>
                      </Col>
                      <Col xs="6">
                        {poBox.name}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-end" xs="6">
                        <b>Email: </b>
                      </Col>
                      <Col xs="6">
                        {poBox.email}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-end" xs="6">
                        <b>Telefono: </b>
                      </Col>
                      <Col xs="6">
                        {poBox.phone}
                      </Col>
                    </Row>
                  </>
                )}
              </LoadingPlaceholder>
            )}
          </CardText>
        </CardBody>
      </Card >
      {props.children}
    </div >
  );
}

export default POBoxDetails;